/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Storefrontoffersdescription2Inputs */

const id_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri toko representatif yang ditemukan di sandbox ini.`)
};

const ms_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri kedai perwakilan yang ditemui dalam sandbox ini.`)
};

const da_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repræsentative butiksposter fundet i denne sandbox.`)
};

const de_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repräsentative Store-Einträge in dieser Sandbox.`)
};

const en_us2_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representative store entries found in this sandbox.`)
};

const es_es2_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de tienda representativas encontradas en este sandbox.`)
};

const es_mx2_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de tienda representativas encontradas en este sandbox.`)
};

const fil_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga representatibong entry sa tindahan na matatagpuan sa sandbox na ito.`)
};

const fr_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrées de vitrine représentatives trouvées dans ce sandbox.`)
};

const it_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci rappresentative del negozio trovate in questo sandbox.`)
};

const hu_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprezentatív bolt bejegyzések ebben a sandbox-ban.`)
};

const nl_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representatieve winkelvermeldingen gevonden in deze sandbox.`)
};

const no_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representative butikkoppføringer funnet i denne sandboxen.`)
};

const pl_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprezentatywne wpisy sklepowe znalezione w tym sandboxie.`)
};

const pt_br2_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas representativas da loja encontradas neste sandbox.`)
};

const pt_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos de loja representativos encontrados nesta sandbox.`)
};

const ro_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înregistrări reprezentative din magazin găsite în acest sandbox.`)
};

const fi_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edustavat kauppapaikan merkinnät tästä hiekkalaatikosta.`)
};

const sv_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representativa butiksposter som finns i denna sandlåda.`)
};

const vi_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các mục cửa hàng đại diện được tìm thấy trong sandbox này.`)
};

const tr_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sandbox'ta bulunan temsili mağaza girişleri.`)
};

const cs_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprezentativní položky obchodu nalezené v tomto sandboxu.`)
};

const bg_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Представителни магазинни записи, намерени в този sandbox.`)
};

const ru_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этой песочнице представлены записи из витрин.`)
};

const uk_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типові записи магазину, знайдені в цьому Sandbox.`)
};

const ar_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات المتجر التمثيلية الموجودة في Sandbox هذا.`)
};

const hi_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सैंडबॉक्स में पाए गए प्रतिनिधि स्टोर प्रविष्टियाँ।`)
};

const th_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการในร้านค้าตัวแทนที่พบในแซนด์บ็อกซ์นี้`)
};

const ja_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサンドボックスで見つかった代表的なストアエントリー。`)
};

const zh_cn2_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此沙盒中代表性的商店条目。`)
};

const zh_hant1_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此沙盒中代表性的商店條目。`)
};

const ko_sandboxes_storefrontoffersdescription2 = /** @type {(inputs: Sandboxes_Storefrontoffersdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Sandbox에서 발견된 대표적인 스토어 항목입니다.`)
};

/**
* | output |
* | --- |
* | "Representative store entries found in this sandbox." |
*
* @param {Sandboxes_Storefrontoffersdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_storefrontoffersdescription2 = /** @type {((inputs?: Sandboxes_Storefrontoffersdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Storefrontoffersdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "da") return da_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "de") return de_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "it") return it_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "no") return no_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "th") return th_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_storefrontoffersdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_storefrontoffersdescription2(inputs)
	return ko_sandboxes_storefrontoffersdescription2(inputs)
});
export { sandboxes_storefrontoffersdescription2 as "sandboxes.storefrontOffersDescription" }